export default __webpack_public_path__ + "static/media/gallery-wip-pommel_01.a0544fca.jpg";